export interface ProjectTemplateWorkbookUploadEventMap {
  '@clatter/PROJECT_TEMPLATE_WORKBOOK_UPLOAD_COMPLETED': undefined;
  '@clatter/PROJECT_TEMPLATE_WORKBOOK_UPLOAD_FAILED': undefined;
}

export class ProjectTemplateWorkbookUploadEvent<K extends keyof ProjectTemplateWorkbookUploadEventMap> extends Event {
  readonly data: { type: K; data: ProjectTemplateWorkbookUploadEventMap[K] };

  constructor(type: K, data: ProjectTemplateWorkbookUploadEventMap[K]) {
    super(type);

    this.data = { type, data };
  }
}

export const subscribe = <K extends keyof ProjectTemplateWorkbookUploadEventMap>(
  eventName: K,
  callback: (event: ProjectTemplateWorkbookUploadEvent<K>) => void,
) => {
  window.addEventListener(eventName, callback as any);

  return () => {
    window.removeEventListener(eventName, callback as any);
  };
};

export const unsubscribe = <K extends keyof ProjectTemplateWorkbookUploadEventMap>(
  eventName: K,
  callback: (event: ProjectTemplateWorkbookUploadEvent<K>) => void,
) => {
  window.removeEventListener(eventName, callback as any);
};

export const publish = <K extends keyof ProjectTemplateWorkbookUploadEventMap>(
  eventName: K,
  data: ProjectTemplateWorkbookUploadEventMap[K],
) => {
  const event = new ProjectTemplateWorkbookUploadEvent(eventName, data);

  window.dispatchEvent(event);
};

export const ProjectTemplateWorkbookUploadEventBus = {
  subscribe,
  unsubscribe,
  publish,
};
